import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/applicationflow')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
